import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AuthGuard} from './_guards/auth.guard';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {HttpClientModule} from '@angular/common/http';
import {SharedModule} from './shared/shared.module';
import {AuthenticatedModule} from './pages/authenticated/authenticated.module';
import {TrackerModule} from './pages/tracker/tracker.module';
import {CommonFunctions} from './helpers/core/common.functions';
import {DataSharing} from './helpers/core/data.sharing';
import {PermissionsGuard} from './_guards/permissions.guard';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouteGuard} from './_guards/route.guard';

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        AuthenticatedModule,
        TrackerModule,
        HttpClientModule,
        SharedModule,
        BrowserAnimationsModule
    ],
    providers: [
        CommonFunctions,
        DataSharing,
        AuthGuard,
        PermissionsGuard,
        RouteGuard
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
